import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-313"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.5 5.27a3.184 3.184 0 0 0-3.185-3.184 3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0A3.185 3.185 0 0 0 15.5 5.27zm-3.185 2.185a2.17 2.17 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.236 1.236 0 0 1 .17.018l.101.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.236 1.236 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369zm-11.167 2.64.978 1.397.977-1.397-.977-1.396-.978 1.396zm2.938 1.456.977 1.397.978-1.397-.978-1.396-.977 1.396zm2.936 1.789L8 14.736l.977-1.396L8 11.943l-.978 1.397zm2.937-1.789.978 1.397.977-1.397-.977-1.396-.978 1.396zm2.937-1.456.978 1.397.978-1.397-.978-1.396-.978 1.396z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }